import { postJson } from '@/util/helpers/ajax-helpers';
import { loading, completed, standardErrorHandler } from './helpers';
import {
  VALIDATED_EXPRESSION,
  VALIDATED_CUSTOM_COLUMNS,
  EVALUATED_CUSTOM_COLUMNS,
} from './constants';

let expressionToValidate = null;
export function validateExpression(columns, expression, replaceExisting) {
  return (dispatch) => {
    expressionToValidate = expression;
    setTimeout(() => {
      if (expressionToValidate !== expression) {
        return; // user has updated the expression
      }
      dispatch(loading(VALIDATED_EXPRESSION));
      postJson('/validateExpression', {
        _columns: columns,
        _expression: expression,
        _replaceExisting: replaceExisting,
      })
        .then((json) => {
          dispatch(
            completed(VALIDATED_EXPRESSION, {
              json,
              expression,
            }),
          );
        })
        .catch(standardErrorHandler(VALIDATED_EXPRESSION, dispatch));
    }, 1000);
  };
}

export function validateCustomColumns(columns, customColumns) {
  return (dispatch) => {
    dispatch(loading(VALIDATED_CUSTOM_COLUMNS));
    postJson('/validateCustomColumns', {
      _columns: columns,
      _custom: customColumns,
    })
      .then((json) => {
        dispatch(completed(VALIDATED_CUSTOM_COLUMNS, { json }));
      })
      .catch(standardErrorHandler(VALIDATED_CUSTOM_COLUMNS, dispatch));
  };
}

export function evaluateCustomColumns(customColumns, headings, rows) {
  return (dispatch) => {
    dispatch(loading(EVALUATED_CUSTOM_COLUMNS));
    postJson('/evaluateCustomColumns', {
      _custom: customColumns,
      _headings: headings,
      _rows: rows,
    })
      .then((json) => {
        dispatch(completed(EVALUATED_CUSTOM_COLUMNS, { json }));
      })
      .catch(standardErrorHandler(EVALUATED_CUSTOM_COLUMNS, dispatch));
  };
}
